import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as contexts from '../contexts'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Enables management of agent assignments for specific entities such as
 * tenants, zones, or applications.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    const contextsFeature = ngCore.inject(contexts.Feature)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'AdminAgentAssignment',
      selectors: () => new Selectors(this, contextsFeature),
    })
    this.registerEffects(
      effects.getUsersOnRequest(),
      effects.requestUsersForAssignment(contextsFeature),
      effects.assignAgentAccessOnRequest(),
    )
  }
}
